import React from "react";
import { useSelector } from "react-redux";

interface LoaderProps {}

const FullScreenLoader = (props: LoaderProps) => {
  const isFullScreenLoading = useSelector(
    (state: any) => state.loading.isFullScreenLoading
  );

  return isFullScreenLoading ? (
    <div className="dui-loader">
      <div className="dui-loader-center">Načítavam...</div>
    </div>
  ) : null;
};

export default FullScreenLoader;
